
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 -1 34 22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M33.495 4.007c0-.047-.016-.089-.027-.135-.01-.037-.016-.078-.031-.11-.016-.036-.043-.062-.064-.093-.026-.036-.052-.078-.084-.11-.005-.004-.01-.015-.016-.02L29.217.156A.693.693 0 0028.779 0H8.955c-.005 0-.01.005-.02.005a.642.642 0 00-.222.042c-.005 0-.005.005-.01.005-.011.005-.022.016-.032.02a.637.637 0 00-.158.105c-.016.015-.032.03-.048.052a.549.549 0 00-.09.135l-.03.062a.532.532 0 00-.048.224v9.4a.63.63 0 00.179.442l.432.457H4.83a.784.784 0 00-.79.78c0 .431.353.78.79.78h5.548l1.296 1.371a.673.673 0 00.48.208c.03 0 .057-.01.089-.015.026.005.047.015.068.015h3.15c.338 3.872 3.63 6.922 7.64 6.922 4.009 0 7.306-3.05 7.638-6.922h2.097a.654.654 0 00.659-.65V4.034c.005-.01 0-.016 0-.026zm-2.455-.624H12.443L10.467 1.3h18.07l2.503 2.084zM10.83 11.08L9.615 9.796V2.297l2.044 2.162v7.494l-.59-.624a.83.83 0 00-.237-.25zm13.493 1.7l2.312-2.282a.388.388 0 000-.55.401.401 0 00-.558 0L23.5 12.493V8.897a.395.395 0 00-.79 0v3.596l-2.577-2.546a.401.401 0 00-.558 0 .388.388 0 000 .55l2.313 2.282h-4.837c.332-3.01 2.92-5.358 6.054-5.358 3.134 0 5.726 2.349 6.053 5.358h-4.836zm-1.217 6.662c-3.14 0-5.727-2.354-6.059-5.363h4.842l-2.318 2.287a.388.388 0 00.279.665c.1 0 .2-.037.28-.115l2.575-2.54v3.595a.395.395 0 00.79 0v-3.596l2.577 2.541c.079.078.179.115.279.115.1 0 .2-.037.28-.115a.388.388 0 000-.55l-2.319-2.287h4.841c-.32 3.014-2.913 5.363-6.047 5.363zm9.077-6.662h-1.439c-.337-3.872-3.63-6.917-7.638-6.917-4.01 0-7.302 3.05-7.64 6.917h-2.491V4.682h19.208v8.097zM2.228 10.944H1.29a.784.784 0 00-.79.78c0 .431.353.78.79.78h.938c.437 0 .79-.349.79-.78a.784.784 0 00-.79-.78z"}})])
          )
        }
      }
    